import { BaseApi } from './base.api.js';

export class AccessLogsApi extends BaseApi {
    constructor(client) {
        super(client, '/access-logs');
    }
}
